/* eslint-disable */
import * as services from '../_services'

/**
 * Creates a generic storage in relation to a service in _service
 * @param {string} service the name of the service exported from _service
 */
// eslint-disable-next-line
const generic_storage = (service) => {
  const state = {
    isLoading: false,
    item: {},
    items: [],
    root: {},
    count: 0,
  }
  const actions = {
    getAll({ commit }, args = null) {
      // console.log('GET ALL = ', args)
      // commit('reset')
      if (args && !args.quiet) {
        commit('setIsLoading', true)
      }
      return services[service].getItems(args).then((response) => {
        commit('updateItemsCount', response.data.count)
        commit('updateItems', response.data.results)
        commit('setIsLoading', false)
        return response
      })
    },
    fetchAll({ commit }, args = null) {
      return actions.getAll({commit}, args)
    },
    addPage({ commit }, args = null) {
      commit('setIsLoading', true);
      return services[service].getItems(args).then((response) => {
        commit('addItemPage', response.data.results)
        commit('updateItemsCount', response.data.count)
        commit('setIsLoading', false)
        return response
      })
    },
    setPage({commit}, items, page, page_size){
      commit('updatePage', {items, page, page_size})
    },
    getItem({ commit }, id) {
      // commit('reset')
      commit('setIsLoading', true)
      return services[service].getItem(id).then((response) => {
        commit('updateItem', response.data)
        commit('setIsLoading', false)
        return response;
      })
    },
    getRoot({ commit }, args = null) {
      // commit('reset')
      commit('setIsLoading', true)
      services[service].getAll(args).then((response) => {
        commit('updateRoot', response.data)
        commit('setIsLoading', false)
        return response
      })
    },
    newItem({ commit }, payload) {
      return services[service].postItem(payload)
    },
    deleteItem({ commit, dispatch }, id) {
      commit('setIsLoading', true);
      try {
        commit('localRemove', id);
      } catch (e) {
        console.error(e);
      }
      return services[service].deleteItem(id).then((response) => {
        dispatch('getAll')
      }).finally(() => {
        commit('setIsLoading', false);
      })
    },
    reset({ commit }) {
      commit('reset')
      // console.log('committing reset!')
    },
  }
  const mutations = {
    reset: () => {
      /** WARNING: this is probably not working due to a plugin for vuex reset state */
      // console.log('Reseting state!')
      state.isLoading = false
      state.item = {}
      state.items = []
      state.root = {}
    },
    updatePage(state, frame){
      let {items, page_number, page_size} = frame;
      state.items.splice(page_size * page_number, page_size, ...items);
    },
    updateItems(state, items) {
      state.items = items
    },
    addItemPage(state, items) {
      state.items.push(...items);
    },
    updateItem(state, item) {
      state.item = item
    },
    updateRoot(state, item) {
      state.root = item
    },
    updateData(state, item) {
      state.item = item
    },
    setIsLoading(state, isLoading) {
      state.isLoading = isLoading
    },
    updateItemsCount(state, item) {
      state.count = item
    },
    localRemove(state, id) {
      state.items = state.items.filter((item) => item.id !== id)
    }
  }

  return {
    namespaced: true,
    state,
    actions,
    mutations,
  }
}

export {
  generic_storage,
}
